import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { FaFile } from "react-icons/fa";
import { CiFileOn } from "react-icons/ci";
import './handbook.css';
 
const Handbook = () => {
    const [handbookData, setHandbookData] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
 
    // Function to get handbook data from the API
    const getHandbookData = async () => {
        try {
            const response = await axios.get('https://backend.ems.hira-tech.co.uk/api/handbook/');
            setHandbookData(response.data); // Update state with fetched data
        } catch (err) {
            console.error("Error fetching handbook data:", err);
            setError(err.response ? err.response.data.message : 'Error fetching data');
        } finally {
            setLoading(false);
        }
    };
 
    useEffect(() => {
        getHandbookData(); // Fetch data on component mount
    }, []);
 
    if (loading) return <p>Loading...</p>;
    if (error) return <p>Error: {error}</p>;
    if (!handbookData) return <p>No handbook available.</p>; // Show a message if no handbook exists
 
    return (
        <div className="container-handbook">
            <div>
                <h1 className='handbook-header'>
                    <FaFile /> Hand Book
                </h1>
                <hr />
                <h2 className='handbook-subheader'>
                    <CiFileOn /> Hira Dental Lab Handbook
                </h2>
                <hr />
            </div>
            <div className="lab-handbook-content">
                <h3 style={{ textAlign: 'center', marginTop: '20px', fontWeight: 'bold' }}>
                    Handbook for Employees of Hira Dental Laboratory
                </h3>
                <h4 style={{ textAlign: 'center', marginTop: '20px', fontWeight: 'bold' }}>
                    Summary
                </h4>
                <div>
                    <div style={{fontSize:'18px'}}dangerouslySetInnerHTML={{ __html: handbookData.summary }} /> {/* Render HTML with styles */}
                </div>
            </div>
        </div>
    );
};
 
export default Handbook;